import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { filterAdminItemsByAccess } from "../../utils/adminAccess";

const ContainerProductPage = ({
    items = [],
    getTo = (x) => x.href || x.to || "#",
    getTitle = (x) => x.text || x.title || x.name || "—",
    getImage = (x) => x.photo || x.image || x.img || "",
    renderActions,
    minCardWidth = 180,
    className = "",
}) => {
    const user = useSelector((state) => state.auth?.user);

    const visibleItems = useMemo(() => {
        return filterAdminItemsByAccess(items, user);
    }, [items, user]);

    if (!visibleItems.length) {
        return (
            <div
                className={`containerProductPage ${className}`}
                style={{ ["--minw"]: `${minCardWidth}px` }}
            >
                <div
                    style={{
                        gridColumn: '1 / -1',
                        padding: 24,
                        borderRadius: 16,
                        background: 'var(--site-panel, #fff)',
                        color: 'var(--site-text, #0f172a)',
                        border: '1px solid var(--site-border, rgba(2, 6, 23, .08))',
                        textAlign: 'center',
                        fontWeight: 800,
                    }}
                >
                    Нет доступных разделов
                </div>
            </div>
        );
    }

    return (
        <div
            className={`containerProductPage ${className}`}
            style={{ ["--minw"]: `${minCardWidth}px` }}
        >
            {visibleItems.map((item, idx) => {
                const to = typeof getTo === "function" ? getTo(item) : getTo;
                const title = typeof getTitle === "function" ? getTitle(item) : getTitle;
                const img = typeof getImage === "function" ? getImage(item) : getImage;

                return (
                    <div className="containerProductPage__cell" key={item._id || item.href || idx}>
                        <NavLink className="containerProductPage__item" to={to}>
                            <div className="containerProductPage__blockImg">
                                {img ? (
                                    <img
                                        src={img}
                                        alt={title}
                                        className="containerProductPage__img"
                                        onError={(e) => {
                                            e.currentTarget.src =
                                                "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='400' height='250'><rect width='100%' height='100%' fill='%232a2d35'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='%23aab2c8' font-family='Arial' font-size='16'>no image</text></svg>";
                                        }}
                                    />
                                ) : (
                                    <div className="containerProductPage__img containerProductPage__img--placeholder" />
                                )}
                            </div>
                            <h4 className="containerProductPage__title">{title}</h4>
                        </NavLink>

                        {typeof renderActions === "function" && (
                            <div className="containerProductPage__actions">
                                {renderActions(item)}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default ContainerProductPage;